import { render, staticRenderFns } from "./PluginLibrary.vue?vue&type=template&id=5841b65e&"
import script from "./PluginLibrary.vue?vue&type=script&lang=js&"
export * from "./PluginLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports